// User discovery binding. Mirrors iOS UsersEndpoints + /users/search.
import { api } from "./client";
import type { UserSearchResult } from "./community-types";

/** Backend requires q to be at least 2 chars (else 400). */
export function searchUsers(q: string): Promise<UserSearchResult[]> {
  return api.get<UserSearchResult[]>("/users/search", { query: { q } });
}

// ── Public profile (clan-mate visible) — mirrors iOS PublicProfileView ────────

export interface PublicQuestionSetSummary {
  id: string;
  title: string;
  created_at: string;
  bulk_count: number;
  item_count: number;
}

export interface TopicMastery {
  topic_slug: string;
  mastery: number;
  attempts: number;
}

export interface PublicProfile {
  user_id: string;
  display_name: string;
  username: string | null;
  avatar_url: string | null;
  joined_at: string;
  total_xp: number;
  tier: number;
  current_streak: number;
  public_question_sets: PublicQuestionSetSummary[];
  aggregate_mastery: TopicMastery[];
  top_topics: string[];
}

export function getPublicProfile(userId: string): Promise<PublicProfile> {
  return api.get<PublicProfile>(`/users/${encodeURIComponent(userId)}/profile`);
}
